import { configureStore } from "@reduxjs/toolkit";
import combineReducers from "../reducers/combineReducers";
import { thunk } from "redux-thunk";

export default configureStore({
  reducer: combineReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
